import { BaseTaskManagerHook } from '@/renderer/scripts/utils/TaskManager/types/hooks';
import { Task, TaskStatus } from './Task';

export enum ManagerAction {
  none = 'none',
  cancelAll = 'cancelAll',
  cancelOne = 'cancelOne',
  pauseAll = 'pauseAll',
  pauseOne = 'pauseOne',
  startAll = 'startAll',
  startOne = 'startOne',
  retryAll = 'retryAll',
  retryOne = 'retryOne',
}
export enum ManagerStatus {
  // 初始化中
  initializing = 'initializing',
  // 闲时状态
  idle = 'idle',
  // 忙时状态
  processing = 'processing',
  // 处理中状态(锁定状态不能进行新动作的处理），
  // 开始、开始全部可以直接解锁
  loading = 'loading',
}
/**
 * Task 运行事件
 */
export enum TaskEvents {
  listUpdate = 'list-update',
  taskFinish = 'task-finish',
  taskUpdate = 'task-update',
}
export interface TaskManagerList<T> {
  running: Task<T>[];
  waiting: Task<T>[];
  finish: Task<T>[];
  list: Task<T>[];
}

export interface TaskManagerOptions<T> {
  type?: string;
  batchLimit: number;
  chunkParallelLimit?: number;
  onStart: (param: BaseTaskManagerHook<T>) => void | Promise<void> | undefined;
  onPause?: Function;
  onCancel?: Function;
  onFinish?: Function;
  onError?: Function;
  onRetry?: Function;
  onStatusChange?: Function;
}

export interface ProgressParams {
  progressText?: string;
  speed?: number;
  ioPercent?: number;
  remainingTime?: string;
  subTaskStatus?: TaskStatus;
}
// 进度触发器
export type ProgressTrigger = (params: ProgressParams) => void;
